import axios from 'axios';

const API_URL = '/api/v1';

export const getMoments = async (token, eventId = null, page = 1, userId = null, filters = {}) => {
  const params = {
    page,
    ...(eventId              ? { event_id: eventId }          : {}),
    ...(userId               ? { user_id: userId }            : {}),
    ...(filters.category     ? { category: filters.category } : {})
  };
  const response = await axios.get(`${API_URL}/moments`, {
    headers: { Authorization: `Bearer ${token}` },
    params
  });
  return response.data;
};

export const getMoment = async (id, token) => {
  const response = await axios.get(`${API_URL}/moments/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const deleteMoment = async (id, token) => {
  await axios.delete(`${API_URL}/moments/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const createMoment = async (eventId, description, date, token) => {
  const response = await axios.post(`${API_URL}/moments`,
    { moment: { event_id: eventId, description, date } },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};
